import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Vessel } from './vessel.model';

@Injectable({
  providedIn: 'root'
})
export class VesselService {

  constructor(private readonly http: HttpClient) {
  }

  getVessel(q: string, licNum: string) {
    const params = {
      q,
      licNum
    };

    return this.http.get<Vessel[]>('vessels/', { params });
  }

}
